(() => {
  'use strict';
  const root = document.getElementById('bbc-profile');
  const account = window.BBC_ACCOUNT;
  if (!root || !account) return;
  const form = document.getElementById('bbc-profile-form');
  const status = document.getElementById('bbc-profile-status');
  const list = document.getElementById('bbc-profile-baby-list');
  const template = document.getElementById('bbc-profile-baby-template');
  const addButton = document.getElementById('bbc-profile-add-baby');
  const saveButton = document.getElementById('bbc-profile-save');
  const signOutButton = document.getElementById('bbc-profile-signout');
  const field = name => form.elements.namedItem(name);
  let user = null;
  let originalBabies = [];
  let loading = false;

  function show(message, state = '') {
    status.textContent = message;
    status.dataset.state = state;
  }
  function babyCards() { return [...list.querySelectorAll('.bbc-profile__baby-card')]; }
  function updateBabyNumbers() {
    babyCards().forEach((card, index) => {
      card.querySelector('[data-baby-number]').textContent = String(index + 1);
      card.querySelector('legend').firstChild.textContent = 'Baby ';
    });
  }
  function addBaby(data = {}) {
    const card = template.content.firstElementChild.cloneNode(true);
    if (data.id) card.dataset.id = data.id;
    card.querySelector('[data-name="name"]').value = data.name || '';
    card.querySelector('[data-name="birth_date"]').value = data.birth_date || '';
    card.querySelector('.bbc-profile__remove').addEventListener('click', () => { card.remove(); updateBabyNumbers(); });
    list.append(card);
    updateBabyNumbers();
  }
  function readBaby(card) {
    return { id: card.dataset.id || null, name: card.querySelector('[data-name="name"]').value.trim() || null, birth_date: card.querySelector('[data-name="birth_date"]').value || null };
  }
  async function loadProfile() {
    loading = true;
    saveButton.disabled = true;
    addButton.disabled = true;
    show('Loading your profile…');
    try {
      await account.ready;
      user = account.getUser();
      if (!user) { account.signIn(); return; }
      const db = account.client;
      const [profileResult, babiesResult] = await Promise.all([
        db.from('bbc_profiles').select('name,phone,sex,age').eq('user_id', user.id).maybeSingle(),
        db.from('bbc_profile_babies').select('id,name,birth_date,created_at').eq('user_id', user.id).order('created_at', { ascending: true })
      ]);
      if (profileResult.error) throw profileResult.error;
      if (babiesResult.error) throw babiesResult.error;
      const profile = profileResult.data || {};
      field('name').value = profile.name || user.user_metadata?.full_name || user.user_metadata?.name || '';
      field('phone').value = profile.phone || '';
      field('sex').value = profile.sex || '';
      field('age').value = profile.age ?? '';
      originalBabies = babiesResult.data || [];
      list.replaceChildren();
      originalBabies.forEach(addBaby);
      show('');
    } catch (error) {
      console.error('Profile load failed', error);
      show(/bbc_profiles|bbc_profile_babies|schema cache|relation .* does not exist/i.test(error?.message || '')
        ? 'Profile storage is not set up yet. Please try again shortly.'
        : 'We couldn’t load your profile. Check your connection and try again.', 'error');
    } finally {
      loading = false;
      saveButton.disabled = !user;
      addButton.disabled = !user;
    }
  }
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (loading || !user) return;
    const name = field('name').value.trim();
    if (!name) { field('name').focus(); show('Please enter your name to save your profile.', 'error'); return; }
    const ageValue = field('age').value.trim();
    const age = ageValue === '' ? null : Number(ageValue);
    if (age !== null && (!Number.isInteger(age) || age < 0 || age > 120)) { field('age').focus(); show('Enter an age from 0 to 120, or leave it blank.', 'error'); return; }
    const babies = babyCards().map(readBaby);
    const invalidDate = babies.some(baby => baby.birth_date && baby.birth_date > new Date().toISOString().slice(0, 10));
    if (invalidDate) { show('A baby’s date of birth can’t be in the future.', 'error'); return; }
    loading = true;
    saveButton.disabled = true;
    addButton.disabled = true;
    show('Saving your profile…');
    try {
      const db = account.client;
      const { error: profileError } = await db.from('bbc_profiles').upsert({
        user_id: user.id, name, phone: field('phone').value.trim() || null, sex: field('sex').value || null, age
      }, { onConflict: 'user_id' });
      if (profileError) throw profileError;
      const activeBabies = babies.filter(baby => baby.name || baby.birth_date);
      for (const baby of activeBabies.filter(item => item.id)) {
        const { error } = await db.from('bbc_profile_babies').update({ name: baby.name, birth_date: baby.birth_date }).eq('id', baby.id).eq('user_id', user.id);
        if (error) throw error;
      }
      const newBabies = activeBabies.filter(item => !item.id).map(({ name, birth_date }) => ({ user_id: user.id, name, birth_date }));
      if (newBabies.length) {
        const { error } = await db.from('bbc_profile_babies').insert(newBabies);
        if (error) throw error;
      }
      const retained = new Set(activeBabies.filter(item => item.id).map(item => item.id));
      const removed = originalBabies.filter(item => !retained.has(item.id)).map(item => item.id);
      if (removed.length) {
        const { error } = await db.from('bbc_profile_babies').delete().eq('user_id', user.id).in('id', removed);
        if (error) throw error;
      }
      show('Your profile is saved.', 'success');
      await loadProfile();
      show('Your profile is saved.', 'success');
    } catch (error) {
      console.error('Profile save failed', error);
      show(/bbc_profiles|bbc_profile_babies|schema cache|relation .* does not exist/i.test(error?.message || '')
        ? 'Profile storage isn’t ready yet. Your details have not been saved.'
        : 'We couldn’t save your profile. Please try again.', 'error');
    } finally {
      loading = false;
      saveButton.disabled = !user;
      addButton.disabled = !user;
    }
  });
  addButton.addEventListener('click', () => { addBaby(); list.lastElementChild?.querySelector('input')?.focus(); });
  signOutButton.addEventListener('click', async () => {
    signOutButton.disabled = true;
    show('Signing out…');
    try { await account.signOut(); location.assign('/'); }
    catch { show('We couldn’t sign you out. Please try again.', 'error'); signOutButton.disabled = false; }
  });
  account.subscribe(next => { if (!next && user) location.assign('/'); });
  void loadProfile();
})();
